<template>
	<div class="user-main" style="background: #f5f5fb;">
		<sidebar :menu-list="menuList" ref="sidebar" />

		<!-- 功能区 -->
		<div class="main" v-if="rightAreaVisible">
			<div :class="{ block: !nonBlockPage }" style="min-height: 780px;">
				<!-- <page-header :levels="breadLevels" v-if="!nonBlockPage" /> -->
				<transition name="el-fade-in" mode="out-in">
					<keep-alive :include="keepAliveViews">
						<router-view @breadcrumbChange="onReceiveBreadcrumbData"></router-view>
					</keep-alive>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import Sidebar from '@/layouts/Sidebar.vue'
import { constantRouterMap as RouterMap } from '@/routes'
// import { websocketLink } from '@/utils/websocket'
import { subjects } from './const.js'
import { intersectionWith } from 'lodash'
import { initJob } from '@/utils/job.js'
// import { SPRouter } from '@/utils/permissionMap.js'
function extraKeepAliveViews(routeArr) {
	let out = []
	let extracter = arr => {
		if (!arr) return

		arr.forEach(el => {
			if (el.meta && el.meta.keepAlive) {
				out.push(el.meta.keepAlive)
			}

			if (el.children && el.children.length > 0) {
				extracter(el.children)
			}
		})
	}

	extracter(routeArr)
	return out
}

export default {
	data() {
		return {
			subjects,
			menuList: [],
			breadLevels: [],
			rightAreaVisible: false
		}
	},
	async mounted() {
		try {
			await this.tokenLogin()
			const data = await this.$api.user.getPermission(0)
			// setTimeout(() => {
			// 	websocketLink(this.websocketCallback)
			// }, 5000)
			this.$store.state.spRouter = data
			this.getMenuList()
			this.refreshBasicBreadcrum()
			await this.getUserInfoUpdate()
      await initJob(this)
			this.rightAreaVisible = true
		} catch (err) {
      // 登录失效直接退出到一键登录页面
			// window.localStorage.removeItem('tokenInfo')
			// window.localStorage.removeItem('accountInfo')
			// window.localStorage.removeItem('vuex.saved')
			// window.localStorage.removeItem('vuex.menu')
      // window.localStorage.removeItem('passTip')
      this.$router.replace('/oneLogin')
		}
	},
	watch: {
		// $route() {
		// 	this.refreshBasicBreadcrum()
		// }
	},
	computed: {
		keepAliveViews() {
			return extraKeepAliveViews(RouterMap)
		},
		nonBlockPage() {
			return this.$route.meta.blockPage !== undefined && !this.$route.meta.blockPage
		},
		isEntryView() {
			let menu = this.$route.matched[0].meta.menu
			return menu.some(el => el.to == this.$route.name)
		}
	},
	components: {
		Sidebar
	},
	methods: {
		websocketCallback(message) {
			window.localStorage.removeItem('tokenInfo')
			window.localStorage.removeItem('accountInfo')
			window.localStorage.removeItem('vuex.saved')
			window.localStorage.removeItem('vuex.menu')
      window.localStorage.removeItem('passTip')
			let url = window.location
			window.location.replace(`${url.origin}${url.pathname}`)
			window.localStorage.setItem('webtip', JSON.stringify({ total: 1, message: message, duration: 0, type: 'error' }))
		},
		async getUserInfoUpdate() {
			const data = await this.$api.account.tokenGetUserInfo()
      if (!data.pwd_expired?.ok) {
        const passTip = localStorage.getItem('passTip') || 0
        const ninetyDaysInMilliseconds = 90 *24 *60 *60 *1000 // 90天
        const timestamp = new Date().getTime()
        if (timestamp - passTip > ninetyDaysInMilliseconds) {
          this.$notify({
            title: '提示',
            duration: 3500,
            dangerouslyUseHTMLString: true,
            message: data.pwd_expired.msg
          });
          localStorage.setItem('passTip', timestamp)
        }
      }
			this.$store.commit('USER_UPDATE_INFO', data)
			this.$store.commit('persist')
		},
		getMenuList() {
			let menu = null
			switch (this.$store.state.user.userInfo?.type) {
				case this.$api.account.types.STUDENT.value:
					menu = this.$route.matched[0].meta.student.menu
					menu = this.dynamicSildebar(menu, 'student')
					break
				case this.$api.account.types.TEACHER.value:
					menu = this.$route.matched[0].meta.teacher.menu
					menu = this.dynamicSildebar(menu, 'teacher')
					break
				case this.$api.account.types.SCHOOL_ADMIN.value:
					menu = this.$route.matched[0].meta.school_admin.menu
					menu = this.dynamicSildebar(menu, 'school')
					break
        case this.$api.account.types.RESEARCH.value:
          menu = this.$route.matched[0].meta.research.menu
					menu = this.dynamicSildebar(menu, 'research')
          break
				case this.$api.account.types.PLATFORM_ADMIN.value:
					menu = this.$route.matched[0].meta.platform_admin.menu
					menu = this.dynamicSildebar(menu, 'platform')
					break
				default:
					menu = this.$route.matched[0].meta.other.menu
					menu = this.dynamicSildebar(this.menuSPRouter(menu, this.$store.state.spRouter), 'other')
					break
			}
			this.menuList = this.$store.state.menu = menu
			localStorage.setItem('vuex.menu', JSON.stringify(this.menuList))
			return menu
		},
		// 动态路由
		menuSPRouter(menu, SPRouter) {
			const matchingElements = []
			menu.forEach(element => {
				SPRouter.forEach(item => {
					let obj = {}
					if (element.secondMenus && item.children) {
						const childMatches = this.menuSPRouter(element.secondMenus, item.children)
						obj.secondMenus = childMatches
					}
          if (element?.subjects == true) {
            const customComparator = (obj1, obj2) => obj1.name == obj2.display_name
            let subject = intersectionWith(this.subjects, item?.children, customComparator)
            let target = subject.map(el2 => {
              return {
                name: `${element.name} - ${el2.name}`,
                title: el2.name,
                to: element.to,
                contextedTo: {
                  context: el2.slug,
                  target: element.to
                },
                sbid: el2.id,
              }
            })
            obj.secondMenus = target
          }
					if (element.name.indexOf(item.display_name) != -1 && item.item_type != 99) {
						obj = { ...item, ...element, ...obj }
						matchingElements.push(obj)
					}
				})
			})
			return matchingElements
		},
		async tokenLogin() {
			const params = new URLSearchParams(window.top?.location.href)
			const params2 = new URLSearchParams('?' + window.top?.location.href.split('?')[1])
			const token =
				params.get('token') ||
				params2.get('token')?.substring(0, params2.get('token')?.indexOf('#/')) ||
				this.$route.query?.token
      const need_relocation = params.get('need_relocation') ||
        params2.get('need_relocation')?.substring(0, params2.get('need_relocation')?.indexOf('#/')) ||
        this.$route.query?.need_relocation
      if (token) {
        // 链接带了token更新一下本地用户的信息
				window.localStorage.removeItem('tokenInfo')
				window.localStorage.removeItem('accountInfo')
				window.localStorage.removeItem('vuex.saved')
				window.localStorage.removeItem('vuex.menu')
        window.localStorage.removeItem('passTip')
        let url = window.location
        if (!need_relocation) {
          const encodeBase64 = (str) => {
            return btoa(encodeURIComponent(str));
          }
          const weburl = encodeBase64(`${url.href}&need_relocation=1`)
          localStorage.setItem('weburl', JSON.stringify({
            decode: `${url.href}&need_relocation=1`,
            encode: weburl,
            old_token: token
          }));
          window.location.replace(url.origin + '/web-token?weburl=' + weburl)
        } else {
          // window.location.replace(`${url.origin}${url.pathname}`)
        }
				window.localStorage.setItem(
					'tokenInfo',
					JSON.stringify({
						access_token: token
					})
				)
				await this.getUserInfoUpdate()
			}
		},
		getQuery(query) {
			if (typeof query === 'object') {
				return query
			}
			if (typeof query === 'function') {
				return query()
			}
		},
		refreshBasicBreadcrum() {
			// 获取当前选中菜单
			let activedMenu = this.getActivedMenu(this.menuList)

			// 不需要理会
			if (this.nonBlockPage) return

			// 没有当选中 tab 信息
			if (!activedMenu) return

			// 一样的，不用更新
			if (this.breadLevels.length > 0 && activedMenu.name == this.breadLevels[0].name) {
				return
			}
			this.breadLevels = []
			this.breadLevels.push(activedMenu)
			this.$store.state.breadLevels = this.breadLevels
		},
		getActivedMenu(menu) {
			let rootEntry = menu.find(el => {
				if (el.contextedTo) {
					return (
						el.contextedTo.target == this.$route.meta.entry_menu && el.contextedTo.context == this.$route.meta.context
					)
				}
				// 处理二级菜单
				if (el.secondMenus) {
					let target = el.secondMenus.filter(el2 => {
						return el2.to == this.$route.meta.entry_menu
					})
					return target[0]
				}
				return el.to == this.$route.meta.entry_menu
			})

			if (rootEntry) {
				if (!rootEntry.secondMenus) {
					return {
						name: rootEntry.name,
						to: {
							name: rootEntry.to,
							query: this.getQuery(rootEntry.query),
							sbid: rootEntry.sbid
						}
					}
				} else {
					// 处理二级菜单
					let target = rootEntry.secondMenus.filter(el => {
						if (rootEntry.subjects) return el.sbid == this.$route.params.sbid
						else return el.to == this.$route.meta.entry_menu
					})
					return {
						name: target[0].name,
						to: {
							name: target[0].to,
							query: this.getQuery(target[0].query),
							sbid: target[0].sbid
						}
					}
				}
			} else {
				return null
			}
		},
		onReceiveBreadcrumbData(data) {
			if (Array.isArray(data) && this.getActivedMenu(this.menuList)) {
				let mergedBreadcrumb = [this.getActivedMenu(this.menuList), ...data]
				if (this.$route.meta.breadcrumProcessor) {
					this.breadLevels = this.$route.meta.breadcrumProcessor.call(this.$route, mergedBreadcrumb)
				} else {
					this.breadLevels = mergedBreadcrumb
				}
			}
		},
		// 从登录信息加载侧边菜单
		dynamicSildebar(sidebar, role) {
			let subject = null
			if (role === 'platform') {
				subject = this.subjects
			} else if (role === 'teacher') {
				subject = this.$store.state.user.userInfo.teachers[0]?.subjects
			} else {
        subject = this.subjects
			}

      let menu = []
      sidebar.forEach(el => {
        if (role === 'teacher' && (el.name == '谱例管理' || el.name == '作品结构管理' || el.name == '跟(带)唱读管理')) {
          let index = subject.findIndex(item => item.name == '美术')
          if(subject?.length == 1 && index != -1) {
            console.log('单学科：美术老师不展示谱例管理、作品结构管理、跟(带)唱读管理')
          } else {
            menu.push(el)
          }
        } else {
          menu.push(el)
        }
      })
			// 插入学科信息
      const processMenu = (menuItem, avIndex = undefined) => {
        return menuItem.map((el, ei) => {
          let processMenuItem
          if (el.subjects) { //配置了subjects学科属性，需要遍历出学科路由
            let target
            if (role === 'other') {
              const customComparator = (obj1, obj2) => obj1.name == obj2.display_name
              subject = intersectionWith(subject, el?.children, customComparator)
            }
            target = subject.map((el2, ei2) => {
              return {
                name: `${el.name} - ${el2.name}`,
                title: el2.name,
                to: el.to,
                contextedTo: {
                  context: el2.slug,
                  target: el.to
                },
                sbid: el2.id,
                activeMenu: avIndex != undefined ? `${avIndex}-${ei}-${ei2}` : `${ei}-${ei2}`
              }
            })
            processMenuItem = { ...el, secondMenus: target, activeMenu: ei.toString() }
          }
          else if (el.secondMenus) { // 有二级菜单
            processMenuItem = {
              ...el,
              secondMenus: processMenu(el.secondMenus, ei).map((item, idx) => { return { ...item, activeMenu: `${ei}-${idx}` } }),
              activeMenu: ei.toString()
            }
          }
          else { // 一级菜单
            processMenuItem = { ...el, activeMenu: ei.toString() }
          }
          return processMenuItem
        })
      }
			return processMenu(menu)
		}
	}
}
</script>
<style lang="scss">
.user-main {
	display: flex;
	.main {
		display: inline-block;
		vertical-align: top;
		// width: calc(100vw - 235px);
		flex: 1;
		// margin-left: 15px;
		// margin-top: 15px;
		// // margin-top: 71px;
		// margin-bottom: 15px;
		margin: 15px;
		margin-right: 25px;
		min-height: 780px;
		overflow-x: hidden;
	}
}
</style>
